<mat-toolbar style="background: #fff;" class="d-flex justify-content-between DU_topbar du-topbar-responsive">
    <button mat-icon-button class="example-icon mr-3 du-side-bar-menu-talet"
        aria-label="Example icon-button with menu icon">
        <mat-icon (click)="menuBar()">menu</mat-icon>
    </button>

    <img  *ngIf="dashboardKey == '20260310105148'" class="du-topnav-logo-desktop mr-1" style="width: 100px; aspect-ratio: 1/0.55;"
        src="assets/Eblu_logo.jpg" alt="logo" (click)="logoclicktoBack()" (error)="logoError = true">

       <img *ngIf="clientLogo && !logoError" class="du-topnav-logo-desktop mr-3" style="width: 150px;aspect-ratio: 1/0.35;"
        [src]="styleLogo(clientLogo)" alt="logo" (click)="logoclicktoBack()" (error)="logoError = true">
    <!-- <img *ngIf="!modulePage && clientLogo" class="du-topnav-logo-desktop mr-3"
        style="width: 150px;aspect-ratio: 1/0.35;" [src]="styleLogo(clientLogo)" alt="logo" (click)="logoclicktoBack()"> -->

    <span *ngIf="!modulePage" class="d-flex justify-content-between align-items-center">
        <mat-icon class="arrow_back_css du-topnav-arrow-back" style="cursor: pointer;"
            (click)="previousPage()">arrow_back</mat-icon>
        <span class="title mx-2" class="nameOfThePage nameOfThePageIN du-topnav-page-name du-header-font-size"
            *ngIf="locationName ? false : true"> {{ pagename || '' }}</span>
    </span>


    <span class="du-topnav-bar-desktop">
        <span *ngIf="routerLoader && locationName ? false : true && prName ? true : false"
            class="verticalLine mx-4"></span>
    </span>

    <span *ngIf="routerLoader" class="du-topnav-bar-desktop">
        <span class="titleprcard mx-2" *ngIf="locationName ? true : false"> {{locationName}}</span>
        <span [ngClass]="prName.includes('Neo') ? 'scraii-ai-prName' : 'titleprcard'" class="mx-2"
            *ngIf="locationName ? false : true">
            {{ moduleKey == 100116 ? prName : (prName | titlecase)}}
        </span>
    </span>

    <span *ngIf="selectedBrandName" class="du-topnav-brand-name" [matTooltip]="selectedBrandName">
        <span class="verticalLine mx-3"></span>
        <span class="title mx-2 du-topnav-brand-text"> {{ selectedBrandName }}</span>
    </span>

    <div class="d-flex align-items-center">
        <!-- Page-level Help info -->
        <!-- <span *ngIf="this.dashboardKey && widgetHelpInfo?.pageInfoChecks">
            <button 
                matTooltip="Help" 
                mat-icon-button
                #infoMenuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="info" 
                style="min-width: 0 !important; padding: 0 !important;line-height: 0px;color: #1363DF;"
                (click)="getInfoDetail()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.5001 16.2687C10.56 21.2088 9.51014 21.3939 4.03756 15.9213C-1.43503 10.4487 -1.25593 9.40488 4.03756 4.11139C9.33104 -1.18209 10.1804 -1.55566 15.8475 4.11139C21.5145 9.77844 21.3201 10.4487 15.5001 16.2687Z" fill="#1363DF"/>
                    <path d="M9.94252 6.27328C10.2308 6.27328 10.4645 6.03961 10.4645 5.75135C10.4645 5.4631 10.2308 5.22942 9.94252 5.22942C9.65427 5.22942 9.42059 5.4631 9.42059 5.75135C9.42059 6.03961 9.65427 6.27328 9.94252 6.27328Z" fill="white"/>
                    <path d="M9.94252 14.6242V10.4487M15.5001 16.2687C10.56 21.2088 9.51014 21.3939 4.03756 15.9213C-1.43503 10.4487 -1.25593 9.40488 4.03756 4.11139C9.33104 -1.18209 10.1804 -1.55566 15.8475 4.11139C21.5145 9.77844 21.3201 10.4487 15.5001 16.2687ZM10.4645 5.75135C10.4645 6.03961 10.2308 6.27328 9.94252 6.27328C9.65427 6.27328 9.42059 6.03961 9.42059 5.75135C9.42059 5.4631 9.65427 5.22942 9.94252 5.22942C10.2308 5.22942 10.4645 5.4631 10.4645 5.75135Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </span> -->
        <!-- Refresh Icon -->
        <span *ngIf="this.refreshTheDashboard">
            <button 
                matTooltip="Refresh" 
                mat-icon-button
                (click)="getRefreshData()" 
                style="min-width: 0 !important; padding: 0 !important;line-height: 0px;color: #1363DF;"
                [class.rotate]="refreshPageData">            
                <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.6633 6.83172H17.6633V1.83172M17.6633 6.83172L13.805 3.19838C12.6555 2.04817 11.1633 1.30271 9.55328 1.07434C7.94325 0.845968 6.30262 1.14706 4.87861 1.93225C3.45459 2.71744 2.32435 3.94418 1.6582 5.42761C0.992042 6.91104 0.826067 8.57079 1.18528 10.1568C1.5445 11.7427 2.40944 13.169 3.64977 14.2206C4.89011 15.2722 6.43863 15.8922 8.062 15.9872C9.68536 16.0822 11.2956 15.647 12.6501 14.7471C14.0046 13.8473 15.03 12.5316 15.5716 10.9984" stroke="#1363DF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </span>
    </div>


    <span class="du-topnav-spacer-refresh">
        <span class="example-spacer"></span>
        <span *ngIf="this.filterService.refreshData" class="refreshedLastdate du-topnav-refresh-wrapper">
            <mat-icon style="width: 17px; height: 17px;" [matTooltip]="displayRefreshDate"
                svgIcon="data_refreshed"></mat-icon>
            <span class="du-topnav-refresh-text" [matTooltip]="displayRefreshDate">
                <span class="mx-1">Last refreshed:</span>
                <span style="color: #000 !important">{{ displayRefreshDate }}</span>
            </span>
        </span>
    </span>
    
    <!-- Schema chnage tab UI  -->
    
    <span *ngIf="showSchemaToggle" class="du-schema-toggle" role="group" aria-label="Schema selection">
        <button type="button" class="du-schema-btn" *ngFor="let option of schemaOptions"
            [class.active]="schemaType === schemaValue(option)"
            [matTooltip]="schemaTooltip(option)"
            [matTooltipDisabled]="!schemaTooltip(option)"
            (click)="onSchemaChange(option)">{{ option.name }}</button>
    </span>

    <!-- Task Management Side Panel trigger -->
    <!-- <ng-container>
        <span (click)="openSidePanel()" class="pe-1 scraii-task-mgmt-icon-wrapper" matTooltip="Task Management">
            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 2048 2048">
                <path fill="#737D87"
                    d="M0 128h2048v1792H0zm1920 128H128v256h1792zM128 1792h1792V640H128zm1280-640V768h384v384zm128-256v128h128V896zm-128 768v-384h384v384zm128-256v128h128v-128zM384 1024V896h768v128zm0 512v-128h768v128z" />
            </svg>


            <span *ngIf="taskCount > 0" class="scraii-task-mgmt-badge">
                {{ taskCount > 99 ? '99+' : taskCount }}
            </span>
        </span>

        <app-task-mgmt-side-panel></app-task-mgmt-side-panel>
    </ng-container> -->

    <!-- <span style="padding: 5px;margin-right: 3px;" *ngIf="this.dashboardKey || this.moduleKey">
        <mat-icon [class.du-disabled-filterloads]="!filterEventFlag"
            [style.color]="this.unreadEventCountValue > 0 ? '#1363DF' : '#737D88'"
            [matBadge]="this.unreadEventCountValue > 0 ? this.unreadEventCountValue : ''" matBadgeColor="warn"
            class="Du-notification-icon-calendar" (click)="loadCalendarView()" [matTooltip]="'Calendar'"
            svgIcon="notification_calendar" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightCalendarView"
            aria-controls="offcanvasRightCalendarView"></mat-icon>
    </span> -->

    <!-- <span style="padding: 5px;" *ngIf="this.dashboardKey  || moduleName == 'direct'">
        <mat-icon class="Du-notification-icon-mail" (click)="openConsentForm()" matTooltip="Mail"
            svgIcon="notification_mail"></mat-icon>
    </span> -->

    <span style="padding: 5px;" *ngIf="this.dashboardKey">
        <mat-icon [class.du-disabled-filterloads]="!filterFlag"
            [style.color]="this.unreadBookmarkTotalCount>0 ? '#1363DF' : '#737D88'"
            [matBadge]="this.unreadBookmarkTotalCount>0 ? this.unreadBookmarkTotalCount : ''" matBadgeColor="warn"
            class="Du-notification-icon-alert" (click)="loadbookMarkView()" [matTooltip]="'Bookmarks'"
            svgIcon="notification_bookmark" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightBookmarkView"
            aria-controls="offcanvasRightBookmarkView"></mat-icon>
    </span>

    <span style="padding: 5px;" *ngIf="this.dashboardKey && isModuleKeyExcludedAlerts">
        <mat-icon [class.du-disabled-filterloads]="!filterFlag"
            [style.color]="this.unreadAlertCount>0 ? '#1363DF' : '#737D88'"
            [matBadge]="this.unreadAlertCount>0 ? this.unreadAlertCount : ''" matBadgeColor="warn"
            class="Du-notification-icon-alert" (click)="loadAlertView()" [matTooltip]="'Alert'"
            svgIcon="notification_alert" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightAlertView"
            aria-controls="offcanvasRightAlertView"></mat-icon>
    </span>

    <span style="padding: 6px;" *ngIf="this.dashboardKey && pdrpRestricted!='Y'">
        <mat-icon [class.du-disabled-filterloads]="!filterFlag"
            [style.color]="this.unreadCount>0 ? '#1363DF' : '#737D88'"
            [matBadge]="this.unreadCount>0 ? this.unreadCount : ''" matBadgeColor="warn"
            class="Du-notification-icon-notes offcanvas-toggle-button" (click)="loadAnnotation()" [matTooltip]="'Notes'"
            svgIcon="notification_notes" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRightAnnotationNotes"
            aria-controls="offcanvasRightAnnotationNotes"></mat-icon>
    </span>

    <span style="padding: 6px;" *ngIf="this.dashboardKey && pdrpRestricted=='Y'">
        <mat-icon matBadgeColor="warn"
            class="Du-notification-icon-notes offcanvas-toggle-button du-disabled-filterloads-pdrp"
            [matTooltip]="'PDRP Restricted'" svgIcon="notification_notes"></mat-icon>
    </span>

    <span class="outer_img_layout du-ipad-hide">
        <img src="../../../../assets/generic_gender.png" alt="Avatar" class="avatar">
    </span>

    <span class="outer_img_layout du-ipad-block">
        <img data-bs-toggle="modal" data-bs-target="#exampleModalProfile" src="../../../../assets/generic_gender.png"
            alt="Avatar" class="avatar">
    </span>

    <span class="user_name du-ipad-hide">{{ userName || ''}}</span>

    <div class="du-ipad-hide">

        <button mat-icon-button class="example-icon du-topnav-bar-desktop" [matMenuTriggerFor]="userMenu">
            <mat-icon style="color:#8A98AB">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #userMenu="matMenu" xPosition="before" class="du-user-menu">
            <button *ngIf="userInfo?.alert_setting_flg=='Y'" mat-menu-item
                (click)="openAlertsPopupDQ()">
                <span class="material-icons" style="color: #1363DF;">notification_important</span>
                <span class="pl-3 mat-item-text-label"> Alert Settings</span>
            </button>

            <button mat-menu-item
                *ngIf="userInfo?.impersonation_flg=='Y' && !usrImp" (click)="impersonation()">
                <span class="material-icons">autorenew</span>
                <span class="pl-3 mat-item-text-label">Impersonate User</span>
            </button>

            <button mat-menu-item *ngIf="usrImp"
                (click)="impersonation()">
                <span class="material-icons">autorenew</span>
                <span class="pl-3 mat-item-text-label">Switch User</span>
            </button>

            <button *ngIf="this.clientLength.length>1" mat-menu-item
                (click)="switchClient()">
                <span class="material-icons">autorenew</span>
                <span class="pl-3 mat-item-text-label">Switch Client</span>
            </button>

            <button mat-menu-item (click)="logout()">
                <span class="material-icons text-danger" style="font-size: 20px;margin-left: 4px;">logout</span>
                <span class="pl-3 mat-item-text-label">Logout</span>
            </button>

            <button mat-menu-item *ngIf="userInfo?.mfa_preference_flg=='Y'" (click)="toggleMfa($event); $event.stopPropagation()">
                <span class="material-icons text-danger" style="font-size: 20px;margin-left: 4px;">fingerprint</span>
                <span class="pl-3 mat-item-text-label">MFA Preferences</span>
            </button>

            <div *ngIf="isMfaOpen" style="padding: 0 10px;" (click)="$event.stopPropagation()">
                <hr>
                <form #f="ngForm">
                    <div class="form-input mt-2">
                        <label class="login_label" style="font-family: poppins !important;font-size: 14px;">Change
                            MFA</label>

                        <div class="form-check">
                            <label class="d-flex align-items-center radio-option"
                                style="margin-bottom: 0;font-family: poppins !important;font-size: 13px;">
                                <input type="radio" name="setupMethod" [(ngModel)]="setupMethod" value="TOTP"
                                    required />
                                <span class="pad-left-25"><strong>Authenticator</strong></span>
                            </label>
                        </div>
                        <div class="form-check">
                            <label class="d-flex align-items-center radio-option"
                                style="margin-bottom: 0;font-family: poppins !important;font-size: 13px;">
                                <input type="radio" name="setupMethod" [(ngModel)]="setupMethod" value="EMAIL"
                                    required />
                                <span class="pad-left-25"><strong>Email OTP</strong></span>
                            </label>
                        </div>
                    </div>

                    <div class="row my-2">
                        <div class="col-12">
                            <button [disabled]="setupMethod==defaultSetupMethod" (click)="updatePreference()"
                                mat-raised-button style="font-family: poppins !important;" [style.width.%]="100"
                                color="primary">
                                <span style="font-size: 13px;"> {{"Confirm"}}</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </mat-menu>

    </div>

</mat-toolbar>

<div id="offcanvasAlertSettings" class="offcanvas offcanvas-end alterts_settings" tabindex="-1"
    aria-labelledby="offcanvasExampleLabel" style="width:40%">
    <app-alert-settings></app-alert-settings>

</div>

<mat-menu #menu="matMenu" class="topNav_user_menu">
    <button class="menu_setting_topnav" mat-menu-item (click)="toggleAlertSettings()" data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasAlertSettings" aria-controls="offcanvasExample">Alert Settings</button>
    <button class="menu_setting_topnav" *ngIf="userInfo?.impersonation_flg=='Y' && !usrImp" mat-menu-item
        (click)="impersonation()">{{ 'Impersonate User' }}</button>
    <button class="menu_setting_topnav" *ngIf="usrImp" mat-menu-item (click)="impersonation()">{{ 'Switch User'
        }}</button>
    <button class="menu_setting_topnav" mat-menu-item (click)="logout()">Logout</button>
</mat-menu>
<!-- <mat-menu #afterMenu="matMenu" class="topNav_user_menu mt-3">
    <a class="menu_setting_topnav" style="text-decoration:'none'" mat-menu-item (click)="toggleAlertSettings()"
        data-bs-toggle="offcanvas" data-bs-target="#offcanvasAlertSettings" aria-controls="offcanvasExample">Alert Settings</a>
    <a class="menu_setting_topnav" style="text-decoration:'none'" mat-menu-item (click)="logout()">Logout</a>
</mat-menu> -->

<mat-menu #beforeMenu="matMenu" [hasBackdrop]="false" xPosition="before">
    <div style="width: 284px;height: 327px;" (click)="$event.stopPropagation()">
        <div class="d-flex justify-content-between flex-container fontStyle" style="align-items: center;">
            <div style="color: #101D42 !important">
                Change avatar
            </div>
            <div>
                <mat-icon (click)="closeMenu()" [svgIcon]="cancel_x"
                    style="cursor: pointer;width: 15px;color: #8A98AB !important;">
                </mat-icon>
            </div>
        </div>
        <div style="padding: 20px 0;text-align: center;">
            <div class="mx-auto" class="outer_img_layout1">

                <img src="../../../../assets/generic_gender.png" alt="Avatar" class="avatar1">
                <!-- <img src="assets/women.png" *ngIf="gender=='F'" alt="Avatar" class="avatar1"> -->
            </div>
            <div style="padding: 10px;">
                <mat-icon style="width: 20px;cursor: pointer;margin: 0px 10px -7px 0;" [svgIcon]="edit">
                </mat-icon>
                <span class="fontColoText" style="color: #1363DF;">
                    Change photo
                </span>
            </div>
            <div style="padding: 5px;">
                <mat-icon style="width: 20px;cursor: pointer;margin: 0px 10px -7px 0;" [svgIcon]="trash">
                </mat-icon>
                <span class="fontColoText" style="color: #D11044;">
                    Delete photo
                </span>
            </div>
        </div>
        <hr style="color: #E8EAEE;">
        <div class="d-flex justify-content-evenly">
            <div>
                <button (click)="closeMenu()" mat-raised-button class="basicBtn btnFonts">Cancel</button>
            </div>
            <div>
                <button mat-raised-button class="primaryBtn btnFonts">Save</button>
            </div>
        </div>


    </div>
</mat-menu>


<!-- Modal -->
<div class="modal fade" id="exampleModalProfile" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog du-top-modal-dialog" style="margin-top: 50px;">
        <div class="modal-content">
            <div class="modal-header justify-content-start">
                <span class="outer_img_layout_profile">
                    <img src="../../../../assets/generic_gender.png" alt="Avatar" class="avatarProfile">
                    <!-- <img src="assets/women.png" *ngIf="gender=='F'" alt="Avatar" class="avatarProfile"> -->
                </span>
                <span style="margin: 5px 10px 0;">
                    <span class="username_profile">{{userName || 'Test'}}</span>
                    <br>
                    <span class="userName_profile_email email_address_CutOF">{{userEmail}}</span>
                </span>
            </div>
            <div class="modal-body" style="margin-left: 10px">

                <button *ngIf="userInfo?.alert_setting_flg=='Y'"
                    class="dropdown-item login_menu_item d-flex align-items-center pb-2" type="button"
                    (click)="openAlertsPopupDQ()" data-bs-dismiss="modal" aria-label="Close">
                    <span class="material-icons" style="color: #1363DF;">notification_important</span>
                    <span class="pl-2 mat-item-text-label"> Alert Settings</span>
                </button>

                <button class="dropdown-item login_menu_item d-flex align-items-center pb-2"
                    *ngIf="userInfo?.impersonation_flg=='Y' && !usrImp" (click)="impersonation()"
                    data-bs-dismiss="modal" aria-label="Close">
                    <span class="material-icons">autorenew</span>
                    <span class="pl-2 mat-item-text-label">Impersonate User</span>
                </button>

                <button class="dropdown-item login_menu_item d-flex align-items-center pb-2" *ngIf="usrImp"
                    (click)="impersonation()" data-bs-dismiss="modal" aria-label="Close">
                    <span class="material-icons">autorenew</span>
                    <span class="pl-2 mat-item-text-label">Switch User</span>
                </button>

                <button *ngIf="this.clientLength.length>1"
                    class="dropdown-item login_menu_item d-flex align-items-center pb-2" (click)="switchClient()"
                    data-bs-dismiss="modal" aria-label="Close">
                    <span class="material-icons">autorenew</span>
                    <span class="pl-2 mat-item-text-label">Switch Client</span>
                </button>

                <button class="dropdown-item login_menu_item d-flex align-items-center pb-2" type="button"
                    (click)="toggleMfa($event)">
                    <span class="material-icons text-danger"
                        style="font-size: 20px;margin-left: 2px;">fingerprint</span>
                    <span class="pl-2 mat-item-text-label">MFA Preferences</span>
                </button>

                <div class="collapse" style="padding: 0 10px;" [class.show]="isMfaOpen" id="collapseExample">
                    <hr>
                    <form #f="ngForm">
                        <!-- Radio options -->
                        <div class="form-input mt-2">
                            <label class="login_label" style="font-family: poppins !important;font-size: 14px;">Change
                                MFA</label>

                            <div class="form-check">
                                <label class="d-flex align-items-center radio-option"
                                    style="margin-bottom: 0;font-family: poppins !important;font-size: 13px;">
                                    <input type="radio" name="setupMethod" [(ngModel)]="setupMethod" value="TOTP"
                                        required />
                                    <span class="pad-left-25"><strong>Authenticator</strong></span>
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="d-flex align-items-center radio-option"
                                    style="margin-bottom: 0;font-family: poppins !important;font-size: 13px;">
                                    <input type="radio" name="setupMethod" [(ngModel)]="setupMethod" value="EMAIL"
                                        required />
                                    <span class="pad-left-25"><strong>Email OTP</strong></span>
                                </label>
                            </div>
                        </div>

                        <div class="row my-2">
                            <div class="col-12">
                                <button [disabled]="setupMethod==defaultSetupMethod" (click)="updatePreference()"
                                    mat-raised-button style="font-family: poppins !important;" [style.width.%]="100"
                                    color="primary">
                                    <span style="font-size: 13px;"> {{"Confirm"}}</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer justify-content-start" style="margin-left: 15px">
                <button class="dropdown-item login_menu_item d-flex align-items-center" type="button"
                    (click)="logout()">
                    <span class="material-icons text-danger" style="font-size: 20px;">logout</span>
                    <span class="pl-2 mat-item-text-label">Logout</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Alert Settings DQ -->
<ng-template #alertsDQ>
    <div>
        <!-- <app-alert-settings-dq></app-alert-settings-dq> -->
        <!-- <app-alerts-dq-dynamic></app-alerts-dq-dynamic> -->
        <app-alert-subscription-dq></app-alert-subscription-dq>
    </div>
</ng-template>


<!-- Annotation -->
<div class="offcanvas offcanvas-end container" style="padding: 0;min-width: 400px;max-width: calc(100% - 180px);"
    #offcanvasRightAnnotationNotes [style.width.px]="data?.width" tabindex="-1" id="offcanvasRightAnnotationNotes"
    aria-labelledby="offcanvasRightAnnotationNotesLabel" data-bs-scroll="true" data-bs-backdrop="false">
    <!-- <app-annotation-view [offcanvasRightAnnotationNotes]="offcanvasRightAnnotationNotes" [annotationIndication]="annotationIndication" (onResizeSideWindow)="onResizeSideWindow($event)"></app-annotation-view> -->
    <app-comments-notes *ngIf="annotationClicked" [offcanvasRightAnnotationNotes]="offcanvasRightAnnotationNotes"
        [annotationIndication]="annotationIndication" [notesConfiguration]="notesConfiguration"
        (onResizeSideWindow)="onResizeSideWindow($event)"></app-comments-notes>

    <!-- Close -->
    <div class="btn-close-bg">
        <mat-icon class="mat-btn-close" data-bs-dismiss="offcanvas"
            (click)="this.unreadLoadApi(this.dashboardKey);annotationClicked=false">clear</mat-icon>
    </div>
</div>

<!-- Calendar -->
<div class="offcanvas offcanvas-end container" style="padding: 0;min-width: 400px;max-width: calc(100% - 180px)"
    #offcanvasRightCalendarView [style.width.px]="data?.width" tabindex="-1" id="offcanvasRightCalendarView"
    aria-labelledby="offcanvasRightCalendarViewLabel" data-bs-scroll="true" data-bs-backdrop="false">
    <app-side-calendar *ngIf="CalendarClicked" [offcanvasRightCalendarView]="offcanvasRightCalendarView"
        [CalendarIndication]="CalendarIndication" (onResizeSideWindow)="onResizeSideWindow($event)"></app-side-calendar>
    <!-- Close -->
    <div class="btn-close-bg">
        <mat-icon class="mat-btn-close" data-bs-dismiss="offcanvas"
            (click)="unreadEventCount(); CalendarClicked=false">clear</mat-icon>
    </div>
</div>

<!-- Secure Mail -->
<div class="offcanvas offcanvas-end container" style="padding: 0;min-width: 400px;max-width: calc(100% - 180px);"
    #offcanvasRightMailView [style.width.px]="data?.width" tabindex="-1" id="offcanvasRightMailView"
    aria-labelledby="offcanvasRightMailViewLabel" data-bs-scroll="true" data-bs-backdrop="false">
    <app-secure-mail *ngIf="secureMailClicked" [offcanvasRightMailView]="offcanvasRightMailView"
        [mailIndication]="mailIndication" (onResizeSideWindow)="onResizeSideWindow($event)"></app-secure-mail>

    <!-- Close -->
    <div class="btn-close-bg">
        <mat-icon class="mat-btn-close" data-bs-dismiss="offcanvas" (click)="secureMailClicked=false">clear</mat-icon>
    </div>
</div>

<!-- Alert -->
<div class="offcanvas offcanvas-end container" style="padding: 0;min-width: 400px;max-width: calc(100% - 180px)"
    #offcanvasRightAlertView [style.width.px]="data?.width" tabindex="-1" id="offcanvasRightAlertView"
    aria-labelledby="offcanvasRightAlertViewLabel" data-bs-scroll="true" data-bs-backdrop="false">
    <app-alert-view *ngIf="alertViewClicked" [offcanvasRightAlertView]="offcanvasRightAlertView"
        [alertIndication]="alertIndication" (onResizeSideWindow)="onResizeSideWindow($event)"></app-alert-view>

    <!-- Close -->
    <div class="btn-close-bg">
        <mat-icon class="mat-btn-close" data-bs-dismiss="offcanvas"
            (click)="this.unreadAlert(this.dashboardKey);alertViewClicked=false">clear</mat-icon>
    </div>
</div>

<!-- Individual Notes -->
<div class="offcanvas offcanvas-end container" style="padding: 0;min-width: 400px;max-width: calc(100% - 180px)"
    #offcanvasRightIndividualView [style.width.px]="data?.width" tabindex="-1" id="offcanvasRightIndividualView"
    aria-labelledby="offcanvasRightIndividualViewLabel">
    <app-individual-notes [offcanvasRightIndividualView]="offcanvasRightIndividualView"
        [individualSelectedData]="this.filterService.individualSelectedData"
        (onResizeSideWindow)="onResizeSideWindow($event)"></app-individual-notes>

    <!-- Close -->
    <div class="btn-close-bg">
        <mat-icon class="mat-btn-close" data-bs-dismiss="offcanvas">clear</mat-icon>
    </div>
</div>


<!-- Bookmark -->
<div class="offcanvas offcanvas-end container" style="padding: 0;min-width: 400px;max-width: calc(100% - 180px)"
    #offcanvasRightBookmarkView [style.width.px]="data?.width" tabindex="-1" id="offcanvasRightBookmarkView"
    aria-labelledby="offcanvasRightBookmarkViewLabel" data-bs-scroll="true" data-bs-backdrop="false">
    <app-bookmark-view *ngIf="bookmarkClicked" [offcanvasRightBookmarkView]="offcanvasRightBookmarkView"
        [bookmarkIndication]="bookmarkIndication" (onResizeSideWindow)="onResizeSideWindow($event)"></app-bookmark-view>

    <!-- Close -->
    <div class="btn-close-bg">
        <mat-icon class="mat-btn-close" data-bs-dismiss="offcanvas"
            (click)="unreadBookmarkTotalApi(this.dashboardKey);bookmarkClicked=false">clear</mat-icon>
    </div>
</div>

<div *ngIf="annotationClicked || bookmarkClicked || alertViewClicked || CalendarClicked || secureMailClicked"
    class="offcanvas-backdrop fade show"></div>

<!-- Global case sidebar — opened from anywhere (e.g. the patient grid's "Cases"
     action) via TaskpanelService.openCaseSidebar(...). Hosted here so it overlays
     the current view without navigating away. -->
<app-global-case-sidebar></app-global-case-sidebar>
<!-- Page-level Help info -->
<mat-menu #info="matMenu">
    <div class="card" style="min-width: 300px;border: none;width: auto;" (click)="$event.stopPropagation()">
        <div class="card-header d-flex justify-content-between align-items-center"
            style="border-bottom: none;background: #ddd;">
            <span style="font-weight: 600;">{{infoData?.info_header || ''}}</span>

            <span (click)="closeInfoMenu()" mat-dialog-close>
                <svg width="16" height="16" style="width: 12px !important;height: 12px !important;" viewBox="0 0 16 16"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.9501 0.409871L8 5.35998L3.04989 0.409871C2.5034 -0.136624 1.61634 -0.136624 1.06985 0.409871L0.409871 1.06985C-0.136624 1.61634 -0.136624 2.5034 0.409871 3.04989L5.35998 8L0.409871 12.9501C-0.136624 13.4966 -0.136624 14.3837 0.409871 14.9302L1.06985 15.5901C1.61634 16.1366 2.5034 16.1366 3.04989 15.5901L8 10.64L12.9501 15.5901C13.4966 16.1366 14.3837 16.1366 14.9302 15.5901L15.5901 14.9302C16.1366 14.3837 16.1366 13.4966 15.5901 12.9501L10.64 8L15.5901 3.04989C16.1366 2.5034 16.1366 1.61634 15.5901 1.06985L14.9302 0.409871C14.3837 -0.136624 13.4966 -0.136624 12.9501 0.409871Z"
                        fill="#1363DF" />
                </svg>
            </span>
        </div>

        <div class="card-body">
            <div [innerHtml]="(infoData?.info_text) || '' "></div>
        </div>
    </div>
</mat-menu>
